import { NgModule } from '@angular/core';
import { provideTransloco, TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { TranslocoHttpLoader } from './transloco-http-loader';
import { LocalizeFieldPipe } from './localize-field.pipe';
import { LocalizeNavGroupTitlePipe } from './localize-nav-group-title.pipe';
import { LocalizedLabelPipe } from './localized-label.pipe';
import { environment } from '../../environments/environment';

@NgModule({
  declarations: [LocalizeFieldPipe, LocalizeNavGroupTitlePipe, LocalizedLabelPipe],
  exports: [TranslocoModule, LocalizeFieldPipe, LocalizeNavGroupTitlePipe, LocalizedLabelPipe],
  providers: [
    provideTransloco({
      config: {
        availableLangs: ['en', 'es'],
        defaultLang: 'en',
        reRenderOnLangChange: true,
        prodMode: environment.production,
        fallbackLang: 'en',
        missingHandler: {
          useFallbackTranslation: true,
          logMissingKey: !environment.production,
        },
      },
      loader: TranslocoHttpLoader,
    }),
  ],
})
export class TranslocoRootModule {
  // Force eager instantiation of TranslocoService during app bootstrap.
  // The service is providedIn:'root' with a tree-shakeable factory whose class
  // definition lives in a lazily-evaluated shared chunk. On a cold first load
  // the chunk may not be fully evaluated when the *transloco directive in a
  // lazy-loaded module (e.g. BorrowerPortalModule) calls inject(TranslocoService),
  // causing the directive's ngOnInit to receive `undefined` and crash with
  // "Cannot read properties of undefined (reading 'config')".
  // Injecting the service here ensures it is created synchronously at startup
  // and anchored in the root injector before any lazy route renders.
  constructor(_translocoService: TranslocoService) {}
}
